<template>
  <div class="homeView">
    <section class="pageContents">
      <div class="pageContents-text container">
        <Hospitals />
      </div>
    </section>
  </div>
</template>

<script>

import Hospitals from '@/components/hospitals.vue';

export default ({
  name: 'HomeView',
    components: {
        Hospitals
    }
  })
</script>
